import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    role: 'BC Agent' // default role
};

const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setRole: (state, action) => {
            state.role = action.payload;
        },
        toggleRole: (state) => {
            state.role = state.role === 'Merchant' ? 'BC Agent' : 'Merchant';
        }
    }
});

export const { setRole, toggleRole } = roleSlice.actions;
export default roleSlice.reducer;
